import React, { FunctionComponent } from "react";
import WizardContainer, { WizardProps } from "../../containers/Wizard";
import { CITY_PATH, CAPTION_PATH } from "../../routing/paths";
import FillOrigamiStep from "../FillOrigamiStep";

const ADDRESS_SPELL_NAME = "address";

const FillOrigamiStepProps = {
  previous: CAPTION_PATH,
  next: CITY_PATH,
  question: "What's the first line of your <%= target %>",
  target: "address",
  spellName: ADDRESS_SPELL_NAME,
  placeholder: "205 W 9th St",
  required: false
};

export const AddressStep: FunctionComponent<WizardProps> = (props: WizardProps) => (
  <FillOrigamiStep wizard={props} {...FillOrigamiStepProps} />
);

export default WizardContainer(AddressStep);
